export * from './inside-platform/InsidePlatform';
export * from './outside-platform/OutsidePlatform';
export * from './data-company/DataCompany';
export * from './modal-political-data/ModalPoliticalData';
export * from './modal-terms-conditions/ModalTermsConditions';
export * from './remembrance/Remembrance';
